/**
 * ╔══════════════════════════════════════════════════════════════╗
 * ║  Tages-Inspiration für das AYU Tagebuch                      ║
 * ║  3 Optionen: Ayurveda-Weisheit, Horoskop/Orakel, Witz       ║
 * ╚══════════════════════════════════════════════════════════════╝
 */

// ═══════════════════════════════════════════════════════════
//  AYURVEDA-WEISHEITEN & MANTRAS (31 Stück — einer pro Tag)
// ═══════════════════════════════════════════════════════════

const quotes = [
  { text: "Wenn die Ernährung falsch ist, ist Medizin nutzlos. Wenn die Ernährung richtig ist, ist Medizin unnötig.", author: "Ayurvedische Weisheit" },
  { text: "Der Körper ist dein Tempel. Reinige ihn, nähre ihn, respektiere ihn.", author: "Astanga Hrdayam" },
  { text: "Gesundheit ist nicht nur die Abwesenheit von Krankheit, sondern ein Zustand vollkommener Balance von Körper, Geist und Seele.", author: "Charaka Samhita" },
  { text: "Lokah Samastah Sukhino Bhavantu — Mögen alle Wesen überall glücklich und frei sein.", author: "Vedisches Mantra" },
  { text: "Wie der Geist, so der Mensch. Binde deinen Geist an das Gute und das Gute wird kommen.", author: "Upanishaden" },
  { text: "Die Natur heilt, der Arzt pflegt nur.", author: "Sushruta Samhita" },
  { text: "Om Namah Shivaya — Ich verneige mich vor dem Göttlichen in mir.", author: "Vedisches Mantra" },
  { text: "Dein Agni, dein Verdauungsfeuer, ist der Schlüssel zu deiner Gesundheit. Hüte es wie eine heilige Flamme.", author: "Ayurvedische Weisheit" },
  { text: "Gleichgewicht ist der Schlüssel. Zu viel von allem wird zu Gift.", author: "Charaka Samhita" },
  { text: "Aham Brahmasmi — Ich bin das Universum. Das Universum ist in mir.", author: "Brihadaranyaka Upanishad" },
  { text: "Der Weise behandelt die Krankheit, bevor sie entsteht. Der gewöhnliche Arzt behandelt die Krankheit, die bereits da ist.", author: "Nei Jing" },
  { text: "Tat Tvam Asi — Du bist Das. Erkenne dich selbst in allem.", author: "Chandogya Upanishad" },
  { text: "Schlaf ist die Amme der Menschheit. Ehre deinen Schlaf wie eine heilige Praxis.", author: "Ayurvedische Weisheit" },
  { text: "Om Shanti Shanti Shanti — Friede in Körper, Geist und Seele.", author: "Vedisches Mantra" },
  { text: "Jede Jahreszeit bringt ihre eigene Medizin. Lebe im Einklang mit der Natur.", author: "Ritucharya (Ayurveda)" },
  { text: "Der Atem ist die Brücke zwischen Körper und Geist. Atme bewusst.", author: "Pranayama-Lehre" },
  { text: "Dein Phänotyp ist kein Schicksal, sondern eine Einladung, dich selbst zu verstehen.", author: "Ayurvedische Weisheit" },
  { text: "So Ham — Ich bin Das. Mit jedem Einatmen: So. Mit jedem Ausatmen: Ham.", author: "Vedisches Mantra" },
  { text: "Wer morgens aufsteht und die Sonne grüßt, ehrt das Leben selbst.", author: "Dinacharya (Ayurveda)" },
  { text: "Nahrung ist die erste Medizin. Iss mit Achtsamkeit und Dankbarkeit.", author: "Charaka Samhita" },
  { text: "Gayatri Mantra: Om Bhur Bhuva Swaha — Wir meditieren über das göttliche Licht, das unseren Geist erleuchtet.", author: "Rig Veda" },
  { text: "Ojas, die Essenz der Vitalität, entsteht durch Freude, Liebe und reine Nahrung.", author: "Ayurvedische Weisheit" },
  { text: "Sarve Bhavantu Sukhinah — Mögen alle glücklich sein. Mögen alle frei von Krankheit sein.", author: "Vedisches Mantra" },
  { text: "Die sechs Geschmacksrichtungen in jeder Mahlzeit bringen Balance in dein Leben.", author: "Ayurvedische Weisheit" },
  { text: "Stille ist die Sprache Gottes. Alles andere ist eine schlechte Übersetzung.", author: "Rumi" },
  { text: "Dein Körper ist das Instrument deiner Seele. Stimme es täglich neu.", author: "Ayurvedische Weisheit" },
  { text: "Om Mani Padme Hum — Das Juwel im Lotus. Mitgefühl für alle Wesen.", author: "Buddhistisches Mantra" },
  { text: "Prakriti ist deine Natur. Vikriti ist dein aktueller Zustand. Der Weg zur Gesundheit führt zurück zu deiner Natur.", author: "Ayurvedische Weisheit" },
  { text: "Wasser, getrunken in kleinen Schlucken über den Tag, ist wie Nektar für deinen Körper.", author: "Charaka Samhita" },
  { text: "Om Gam Ganapataye Namaha — Mögen alle Hindernisse beseitigt werden.", author: "Ganesh Mantra" },
  { text: "Jeder Mensch ist einzigartig. Was für den einen Medizin ist, kann für den anderen Gift sein.", author: "Ayurvedische Weisheit" },
];

// ═══════════════════════════════════════════════════════════
//  WITZE DES TAGES (31 Stück — Ayurveda-Humor, charmant)
// ═══════════════════════════════════════════════════════════

const jokes = [
  "Warum meditieren Nervöse Typen so ungern? Weil sie nach 5 Sekunden schon drei neue Ideen haben.",
  "Mein AYU-Coach sagt, ich soll warmes Wasser trinken. Mein innerer Empfindlicher Rötlicher sagt: 'Mach mir lieber einen Espresso.'",
  "Was sagt der Dicke Stabile morgens? 'Noch fünf Minuten...' — und das seit drei Stunden.",
  "Ich wollte heute Pranayama machen, aber mein Atem hatte andere Pläne.",
  "Warum ist Ghee der beste Freund? Es passt zu allem und macht alles besser — genau wie ein guter Coach.",
  "Mein Phänotyp und ich haben eine komplizierte Beziehung. Er kommt und geht, wie er will.",
  "Was ist der Unterschied zwischen einem Dünnhäutigen Nervösen und einem Eichhörnchen? Das Eichhörnchen findet seine Nüsse wieder.",
  "Ich hab heute meine Komfortzone verlassen. Dann bin ich direkt wieder reingegangen — mein innerer Dicker Stabiler war stärker.",
  "Warum gehen Empfindliche Rötliche nie zum Buffet? Weil sie alles organisieren wollen, bevor jemand essen darf.",
  "Mein Agni und ich haben ein Abkommen: Ich esse achtsam, und es verbrennt alles. Meistens.",
  "Was sagt der Ayurveda-Koch? 'Die sechs Geschmäcker müssen alle dabei sein!' — Mein Kühlschrank sagt: 'Viel Glück.'",
  "Ich wollte heute ayurvedisch kochen. Nach dem dritten Gewürz hab ich Pizza bestellt.",
  "Warum ist Achtsamkeit wie Kurkuma? Man sieht sie nicht, aber wenn sie fehlt, merkt man es sofort.",
  "Mein Körper ist ein Tempel. Leider eher so ein antiker, der ein bisschen Panchakarma braucht.",
  "Was macht ein Heller Trockener im Supermarkt? Er kauft alles, was bunt ist, und vergisst die Hälfte an der Kasse.",
  "Ich hab versucht, mein Nervensystem zu beruhigen. Es kam zurück — mit drei neuen Projekten.",
  "Warum sind Dicke Stabile die besten Freunde? Sie sind immer da. Buchstäblich. Sie bewegen sich nicht.",
  "Mein Ayurveda-Berater sagt, ich soll im Einklang mit der Natur leben. Mein Wecker sagt was anderes.",
  "Was ist Selbstfürsorge auf Ayurvedisch? Warmes Sesamöl, überall. Wirklich überall.",
  "Ich hab heute mein drittes Auge gesucht. Es war hinter dem Bildschirm.",
  "Warum trinken Empfindliche Rötliche so viel Kokoswasser? Weil jemand ihr inneres Feuer löschen muss.",
  "Mein Ojas und ich haben eine On-Off-Beziehung. Es kommt nur, wenn ich genug schlafe.",
  "Was sagt der Helle Trockene zum Wind? 'Endlich jemand, der mich versteht!'",
  "Ich wollte heute achtsam essen. Nach dem dritten Laddu hab ich aufgehört zu zählen.",
  "Warum ist Lachen die beste Medizin? Weil es keine Nebenwirkungen hat. Außer dass dein innerer Empfindlicher Rötlicher sich aufregt.",
  "Mein Unterbewusstsein und mein Phänotyp reden nicht mehr miteinander. Zu viel Ama.",
  "Was macht ein Ayurveda-Arzt am Wochenende? Abhyanga — natürlich mit warmem Sesamöl.",
  "Ich hab heute meine Glaubenssätze hinterfragt. Mein innerer Dicker Stabiler hat gesagt: 'Lass mal, ist gut so.'",
  "Warum trinken Ayurveda-Fans so viel Ingwertee? Weil Agni nicht von alleine brennt.",
  "Mein Stresslevel ist wie mein Nervensystem — unberechenbar, aber es geht immer wieder vorbei.",
  "Was ist der Unterschied zwischen Yoga und Bier? Bei Yoga entspannst du dich von innen nach außen. Bei Bier von außen nach innen.",
];

// ═══════════════════════════════════════════════════════════
//  STERNZEICHEN & AYURVEDISCHES HOROSKOP
// ═══════════════════════════════════════════════════════════

const zodiacSigns = [
  { name: "Widder", symbol: "♈", from: [3, 21], to: [4, 19] },
  { name: "Stier", symbol: "♉", from: [4, 20], to: [5, 20] },
  { name: "Zwillinge", symbol: "♊", from: [5, 21], to: [6, 20] },
  { name: "Krebs", symbol: "♋", from: [6, 21], to: [7, 22] },
  { name: "Löwe", symbol: "♌", from: [7, 23], to: [8, 22] },
  { name: "Jungfrau", symbol: "♍", from: [8, 23], to: [9, 22] },
  { name: "Waage", symbol: "♎", from: [9, 23], to: [10, 22] },
  { name: "Skorpion", symbol: "♏", from: [10, 23], to: [11, 21] },
  { name: "Schütze", symbol: "♐", from: [11, 22], to: [12, 21] },
  { name: "Steinbock", symbol: "♑", from: [12, 22], to: [1, 19] },
  { name: "Wassermann", symbol: "♒", from: [1, 20], to: [2, 18] },
  { name: "Fische", symbol: "♓", from: [2, 19], to: [3, 20] },
];

const horoscopeMessages: Record<string, string[]> = {
  "Widder": [
    "Dein Pitta-Feuer brennt heute besonders stark — nutze die Energie für Bewegung und Taten.",
    "Mars schenkt dir heute Mut. Geh raus, beweg dich, und lass dein Agni lodern.",
    "Vertraue deinem Instinkt. Dein inneres Feuer führt dich richtig.",
    "Heute ist ein Tag für Surya Namaskar — der Sonnengruß gibt dir Kraft.",
    "Kühle Nahrung und Kokoswasser helfen dir, dein Pitta in Balance zu halten.",
  ],
  "Stier": [
    "Dein Kapha schenkt dir heute Ruhe und Beständigkeit. Genieße die Erdung.",
    "Gönn dir heute ein warmes Ölbad — Abhyanga nährt deine Haut und Seele.",
    "Die kleinen Freuden machen den Unterschied. Ein warmes Gewürzgetränk am Morgen.",
    "Ingwer und Kurkuma stärken heute dein Agni besonders gut.",
    "Lass dich nicht hetzen — dein Kapha-Tempo ist genau richtig.",
  ],
  "Zwillinge": [
    "Dein Vata ist heute besonders aktiv — erden dich mit warmen Mahlzeiten.",
    "Schreib deine Gedanken auf — dein Tagebuch ist heute dein bester Freund.",
    "Nasya (Nasenöl) kann helfen, deinen überaktiven Geist zu beruhigen.",
    "Warmes Sesamöl auf die Fußsohlen vor dem Schlafen bringt Ruhe.",
    "Abwechslung tut dir gut, aber vergiss die Pausen nicht — Vata braucht Routine.",
  ],
  "Krebs": [
    "Dein Kapha-Wasser schenkt dir heute tiefes Mitgefühl. Teile es mit anderen.",
    "Warme Milch mit Ashwagandha am Abend stärkt dein Ojas.",
    "Dein Zuhause ist dein Kraftort — mach es dir heute besonders gemütlich.",
    "Höre auf dein Bauchgefühl — dein Agni weiß mehr als du denkst.",
    "Heute darfst du weich sein. Kapha-Energie ist Liebe in Aktion.",
  ],
  "Löwe": [
    "Dein Pitta strahlt heute besonders hell — inspiriere andere mit deinem Licht.",
    "Zeig dich, wie du bist — Authentizität ist die höchste Form von Prana.",
    "Aloe-Vera-Saft kühlt dein inneres Feuer und lässt dich noch klarer strahlen.",
    "Kreativität fließt heute besonders leicht — folge deinem Herzchakra.",
    "Pitta-Typen brauchen Abkühlung: Mondlicht, Kokosnuss, sanfte Musik.",
  ],
  "Jungfrau": [
    "Dein Vata-Erde-Element gibt dir heute analytische Klarheit. Nutze sie.",
    "Triphala am Abend unterstützt deine natürliche Reinigung.",
    "Deine Aufmerksamkeit für Details ist ein Geschenk — auch für deine Gesundheit.",
    "Dein Körper dankt dir für jede kleine Aufmerksamkeit. Heute: warmes Frühstück.",
    "Heute ist ein guter Tag für Dinacharya — deine ayurvedische Morgenroutine.",
  ],
  "Waage": [
    "Balance ist dein Lebensthema — und heute besonders wichtig für dein Vata.",
    "Harmonie in der Ernährung: Alle sechs Geschmacksrichtungen in einer Mahlzeit.",
    "Schönheit liegt in der Einfachheit. Ein Spaziergang in der Natur reicht.",
    "Brahmi-Tee stärkt heute deinen Geist und bringt Klarheit.",
    "Ein Spaziergang bei Sonnenuntergang bringt dein Vata in Balance.",
  ],
  "Skorpion": [
    "Dein Pitta-Wasser gibt dir heute transformative Kraft. Nutze sie weise.",
    "Panchakarma-Gedanke: Was kannst du heute loslassen, das dir nicht mehr dient?",
    "Vertraue dem Prozess der Veränderung — Transformation ist deine Natur.",
    "Heute ist ein guter Tag für eine Detox-Suppe mit Kitchari.",
    "Deine Intuition ist heute besonders stark — dein drittes Auge ist wach.",
  ],
  "Schütze": [
    "Dein Pitta-Feuer und Vata-Luft treiben dich heute zu neuen Horizonten.",
    "Bewegung und frische Luft tun dir heute besonders gut — Vata liebt Weite.",
    "Freiheit beginnt im Kopf — und mit einem guten Pranayama am Morgen.",
    "Chyawanprash stärkt heute dein Immunsystem für alle Abenteuer.",
    "Lachen ist Medizin — heute erst recht. Dein Agni dankt es dir.",
  ],
  "Steinbock": [
    "Dein Vata-Erde gibt dir heute Ausdauer und Disziplin. Bleib bei dir.",
    "Schritt für Schritt — Ayurveda ist ein Marathon, kein Sprint.",
    "Warmes Sesamöl-Abhyanga stärkt deine Knochen und Gelenke.",
    "Disziplin und Selbstfürsorge schließen sich nicht aus — beides ist Dharma.",
    "Gönn dir heute eine Pause — auch Steinböcke brauchen Ojas-Aufbau.",
  ],
  "Wassermann": [
    "Dein Vata-Luft schenkt dir heute visionäre Gedanken. Erden dich dabei.",
    "Denke groß — die Welt braucht deine Ideen. Aber vergiss das Frühstück nicht.",
    "Verbindung entsteht durch Authentizität — und durch gemeinsames Essen.",
    "Heute ist ein guter Tag für kreative Lösungen — Vata-Energie im besten Sinne.",
    "Ashwagandha am Abend erdet deinen überaktiven Geist.",
  ],
  "Fische": [
    "Dein Kapha-Wasser gibt dir heute tiefe Intuition. Vertraue ihr.",
    "Kreativität fließt durch dich — lass sie raus. Dein Prana will sich ausdrücken.",
    "Mitgefühl mit dir selbst ist der erste Schritt zur Heilung.",
    "Wasser ist dein Element — trink heute besonders viel warmes Wasser.",
    "Meditation oder Yoga Nidra tun dir heute besonders gut.",
  ],
};

// ═══════════════════════════════════════════════════════════
//  EXPORT-FUNKTIONEN
// ═══════════════════════════════════════════════════════════

/** Gibt die Ayurveda-Weisheit des Tages basierend auf dem aktuellen Datum zurück */
export function getDailyQuote(): { text: string; author: string } {
  const today = new Date();
  const dayOfYear = Math.floor(
    (today.getTime() - new Date(today.getFullYear(), 0, 0).getTime()) / 86400000
  );
  return quotes[dayOfYear % quotes.length];
}

/** Gibt den Tageswitz basierend auf dem aktuellen Datum zurück */
export function getDailyJoke(): string {
  const today = new Date();
  const dayOfYear = Math.floor(
    (today.getTime() - new Date(today.getFullYear(), 0, 0).getTime()) / 86400000
  );
  return jokes[dayOfYear % jokes.length];
}

/** Ermittelt das Sternzeichen basierend auf dem Geburtsdatum */
export function getZodiacSign(birthMonth: number, birthDay: number): { name: string; symbol: string } | null {
  for (const sign of zodiacSigns) {
    const [fromMonth, fromDay] = sign.from;
    const [toMonth, toDay] = sign.to;

    // Sonderfall Steinbock (Dezember-Januar)
    if (fromMonth > toMonth) {
      if (
        (birthMonth === fromMonth && birthDay >= fromDay) ||
        (birthMonth === toMonth && birthDay <= toDay)
      ) {
        return { name: sign.name, symbol: sign.symbol };
      }
    } else {
      if (
        (birthMonth === fromMonth && birthDay >= fromDay) ||
        (birthMonth === toMonth && birthDay <= toDay) ||
        (birthMonth > fromMonth && birthMonth < toMonth)
      ) {
        return { name: sign.name, symbol: sign.symbol };
      }
    }
  }
  return null;
}

/** Gibt das ayurvedische Tageshoroskop für ein Sternzeichen zurück */
export function getDailyHoroscope(zodiacName: string): string {
  const messages = horoscopeMessages[zodiacName];
  if (!messages) return "";
  const today = new Date();
  const dayOfYear = Math.floor(
    (today.getTime() - new Date(today.getFullYear(), 0, 0).getTime()) / 86400000
  );
  return messages[dayOfYear % messages.length];
}

/** Versucht das Geburtsdatum aus den Anamnese-Daten zu extrahieren */
export function extractBirthDate(anamneseData: unknown): { month: number; day: number } | null {
  if (!anamneseData || typeof anamneseData !== "object") return null;

  const data = anamneseData as Record<string, unknown>;

  // SurveyResponse Format
  if (data.completedSections && data.answers) {
    const answers = data.answers as Record<string, { answer?: string }[]>;
    for (const sectionAnswers of Object.values(answers)) {
      if (!Array.isArray(sectionAnswers)) continue;
      for (const a of sectionAnswers) {
        if (a.answer && /\d{1,2}\.\d{1,2}\.\d{2,4}/.test(a.answer)) {
          const match = a.answer.match(/(\d{1,2})\.(\d{1,2})\.(\d{2,4})/);
          if (match) {
            return { day: parseInt(match[1]), month: parseInt(match[2]) };
          }
        }
      }
    }
  }

  // AnamneseData Format
  if ("personalInfo" in data) {
    const personalInfo = data.personalInfo as Record<string, string>;
    if (personalInfo?.geburtsdatum) {
      const match = personalInfo.geburtsdatum.match(/(\d{1,2})\.(\d{1,2})\.(\d{2,4})/);
      if (match) {
        return { day: parseInt(match[1]), month: parseInt(match[2]) };
      }
    }
  }

  return null;
}

/**
 * Extrahiert Monat und Tag aus einem ISO-Datum-String (YYYY-MM-DD).
 */
export function parseBirthdateString(dateStr: string): { month: number; day: number } | null {
  const match = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return null;
  return { month: parseInt(match[2]), day: parseInt(match[3]) };
}

/** Typ für die drei Tages-Optionen */
export type DailyOption = "quote" | "horoscope" | "joke";

/** Gibt alle drei Tages-Optionen zurück */
export function getAllDailyOptions(zodiacName?: string | null): {
  quote: { text: string; author: string };
  horoscope: string | null;
  joke: string;
} {
  return {
    quote: getDailyQuote(),
    horoscope: zodiacName ? getDailyHoroscope(zodiacName) : null,
    joke: getDailyJoke(),
  };
}
